<template>
  <div class="wall">
    <el-result icon="warning" title="激活开户" subTitle="您的账户尚未完成支付开户流程，请开通后继续操作" />

    <rs-form ref="userForm"
      :rules="rules"
      :errors="formError"
      :model="formData"
      :loading="uploadLoading"
      label-width="140px"
      class="mt-10 p-30"
      element-loading-text="等待支付公司处理..."
    >
      <rs-form-item label="对公账号" prop="bank_account" required>
        <el-input v-model="formData.bank_account" />
      </rs-form-item>
      <rs-form-item label="开户行名称" prop="bank_name" required>
        <el-select v-model="formData.bank_name" filterable class="w-100" placeholder="请选择">
          <el-option
            v-for="item in bankList"
            :key="item.name"
            :label="item.name"
            :value="item.name"
          />
        </el-select>
      </rs-form-item>
      <rs-form-item label="开户支行" prop="bank_branch" required>
        <div class="d-flex">
          <el-select v-model="formData.bank_province" @change="handleSelectProvince">
            <el-option
              v-for="item in province"
              :key="item.name"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
          <el-select v-model="formData.bank_city" class="ml-10">
            <el-option
              v-for="item in city"
              :key="item.name"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
          <div class="flex-body pl-10">
            <el-input v-model="formData.bank_branch" placeholder="支行名称" />
          </div>
        </div>
      </rs-form-item>
      <rs-form-item label="企业营业执照" prop="license" required>
        <uploader v-model="formData.license" :showSizeInfo="false" />
      </rs-form-item>
      <rs-form-item label="法人身份证正面" prop="card_front" required>
        <uploader v-model="formData.card_front" :showSizeInfo="false" />
      </rs-form-item>
      <rs-form-item label="法人身份证反面" prop="card_back" required>
        <uploader v-model="formData.card_back" :showSizeInfo="false" />
      </rs-form-item>
      <rs-form-item>
        <el-button type="primary" :loading="btnLoading" @click="handleSubmit">提交</el-button>
      </rs-form-item>
    </rs-form>
  </div>
</template>

<script>
import { getBankList } from '@/api/pay.js'
import { getArea } from '@/api/area.js'
import { registerPayAccount, activePayAccount } from '@/api/shop.js'
import Uploader from '@/components/Uploader.vue';

export default {
  components: {
    Uploader
  },
  data() {
    return {
      btnLoading: false,
      uploadLoading: false,
      formData: {},
      formError: {},
      bankList: [],
      province: [],
      city: [],
      rules: {}
    }
  },
  created() {

    getBankList().then(res => {
      this.bankList = res || []
    })

    getArea(0).then(res => {
      this.province = res
      getArea(res[0].id).then(res => {
        this.city = res.subs || []
      })
    })
  },
  methods: {

    handleSelectProvince(id) {
      getArea(id).then(res => {
        this.city = res.subs || []
      })
    },
    async handleSubmit() {
      const { license, card_front, card_back, ...regData } = this.formData

      try {
        this.btnLoading = true
        await registerPayAccount(regData)

        this.uploadLoading = true
        await activePayAccount({ license, card_front, card_back })

        this.btnLoading = false
        this.uploadLoading = false

        this.$alert('你的账户激活已提交，我们会向您的登陆邮箱发送一封激活确认邮件，请注意查收，并完成操作', '提示', {
          confirmButtonText: '确定',
          callback: () => {
            this.$router.push('/')
          }
        });
      } catch (e) {
        this.btnLoading = false
        this.uploadLoading = false
        if (e.statusCode == 400) {
          this.formError = e.data
        } else {
          alert(e.data.error || '发生错误请联系管理员' + JSON.stringify(e.data))
        }
      }
    },
  }
}
</script>
